import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { SelectMeasureLoader } from "components/measures/SelectMeasureLoader";
import { MeasureSelectPageSkeleton } from "components/skeletons/MeasureSelectPageSkeleton";

export function SelectMeasurePage() {
  const { uuid, footerRef, mapRef, mapOverlayContainer } =
    useUuidLayoutContext();

  return (
    <ErrorBoundary
      FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
    >
      <Suspense
        fallback={
          <MeasureSelectPageSkeleton
            footerRef={footerRef}
            mapOverlayContainer={mapOverlayContainer}
          />
        }
      >
        <SelectMeasureLoader
          uuid={uuid}
          mapRef={mapRef}
          footerRef={footerRef}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
